import React, { FC } from 'react';
import styles from './modal_scrollable_body.module.scss';

export const ModalScrollableBody: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
